import React, { FC } from 'react'
import { useReactiveVar } from '@apollo/client'

import { activeArtistVar, activeProjectVar } from 'modulesCommon/store'

import { ProjectMetrics } from 'components'
import { isEmpty } from 'shared/utils/isEmpty'
import { SkeletonProjectMetrics } from 'modulesCommon/Skeleton/ProjectDetails'
import { IProject, IArtist } from 'shared/interfaces'
import { useLocalProjectFlags, useProjectParent } from 'modulesCommon/serviceHooks'
import { gpsStatusIcons } from 'shared/utils/gpsStatusIcons'
import { OwnerValue } from 'components/ProjectMetrics/Item'

const ProjectMetricsContainer: FC = () => {
  // TODO: Update type reactive vars from any to real type
  const activeProject = useReactiveVar<IProject>(activeProjectVar)
  const activeArtist = useReactiveVar<IArtist>(activeArtistVar)
  const { isLocalized } = useLocalProjectFlags(activeProject)
  const parentProject = useProjectParent(activeProject)

  const projectMetricts = [{
    title: 'GPS Status:',
    icon: 'badge-check',
    value: gpsStatusIcons[activeArtist.gps_status]?.description
  }, {
    title: 'Genre:',
    icon: 'user-music',
    value: activeArtist?.gcdm_info?.genre
  }, {
    title: 'Repertoire Owner:',
    icon: 'user',
    value: activeArtist?.gcdm_info?.company,
    hidden: !isLocalized
  }, {
    title: 'Global Project Owner:',
    icon: 'user',
    value: parentProject?.user ? <OwnerValue user={parentProject.user} /> : '',
    hidden: !isLocalized
  }, {
    title: 'Local Unit:',
    icon: 'circle-dot',
    value: activeProject?.unit?.name
  }, {
    title: 'Local Project Owner:',
    icon: 'user',
    value: activeProject?.user ? <OwnerValue user={activeProject.user} /> : '',
  }]

  const metrics = projectMetricts.filter((metric) => !metric?.hidden)

  return !isEmpty(activeProject) && !isEmpty(activeArtist) ? (
    <ProjectMetrics
      projectMetricts={metrics}
      isaacLinks={activeProject?.isaac_url ?? []}
      globalIsaakLinks={isLocalized && parentProject?.isaac_url ? parentProject?.isaac_url : []}
      artist={activeArtist}
    />
  ) : <SkeletonProjectMetrics />
}

export default ProjectMetricsContainer
